import React from 'react'
import classes from './Toolbar.module.css'
import NavigationItems from '../NavigationItems/NavigationItems'
import GlossareadIcon from '../../../Assests/Image/glossaread_logo_transparent.png'
import SideBarToggle from '../SidebarToggle/SidebarToggle'
import {Link} from 'react-router-dom'
const Toolbar = (props) => {

    return (
        <div>
        <header className={classes.Toolbar}>
          <Link to="/"><img src={GlossareadIcon} className={classes.icon}/></Link>
            <nav>
            <SideBarToggle ToggleSidebar = {props.ToggleSidebar}/>
                 <NavigationItems /> 
            </nav>
        </header>
        </div>
    )

}
export default Toolbar;